// «Hva er nytt»-modul — folkelig og spennende presentasjon av hva
// som har endret seg i appen. Viser en liten Nytt-pille i topbaren
// inntil brukeren har åpnet modalen.

const LS_KEY = 'ca26_changelog_seen';

// Bump versjonen når du legger til nytt innslag — da dukker pillen opp.
export const CHANGELOG_VERSION = '2026-07-10c';

const ENTRIES = [
  {
    date: '10. juli 2026',
    title: 'Skriv ut hele pakkelista på papir',
    body: 'Ny «🖨️ Skriv ut»-knapp øverst på Pakkeliste-siden lager en ren, strukturert utskrift av alt dere skal ha med — alle åtte kategoriene med avkryssingsbokser, i to kolonner så det får plass på færrest mulig ark. Perfekt å henge på kjøleskapet eller ha ved kofferten. Lagre som PDF eller skriv ut direkte. Utskriften er uten vær-oversikten — bare selve tingene.',
  },
  {
    date: '10. juli 2026',
    title: 'Pakkelista vet hvordan været blir der dere skal',
    body: 'Øverst på Pakkeliste-siden ligger nå «🌦 Typisk vær i reiseperioden»: region for region — Vancouver, Alaska-cruiset, indre BC, Rockies, Calgary og Reykjavík — med typiske dag- og natt-temperaturer, hvor vått det pleier å være, og hva det betyr for kofferten. Alaska er kaldt og vått til sjøs, indre BC kan nå 30°C, og Rockies svinger fra frost om morgenen til sol midt på dagen. Bygger på klimanormaler for juli–august, så det virker allerede nå, lenge før live-varselet (7 dager) slår inn.',
  },
  {
    date: '10. juli 2026',
    title: 'Reisevakt — vet om veistengninger og branner på ruten',
    body: 'Øverst på «I dag» ligger nå et «🚦 Reisevakt»-kort. Det henter live vei- og hendelsesvarsler fra DriveBC og 511 Alberta langs akkurat deres rute — og løfter fram det som betyr noe: skogbranner, stengte veier og større hendelser. Er det en brannstenging på Highway 1, vet dere det før dere kjører. Virker også offline (viser sist hentede varsler).',
  },
  {
    date: '10. juli 2026',
    title: 'Live flystatus og nedtelling til neste fly',
    body: 'Flystatus-fanen har fått ekte live-status: trykk «Live status» på en avgang for gate, terminal og forsinkelse, hentet direkte fra flydataene. Øverst teller appen ned til neste avgang og minner dere på når online innsjekk åpner (24 t før) og når dere bør møte (3 t før på utenlandsfly). FlightAware-lenken ligger der fortsatt som backup.',
  },
  {
    date: '10. juli 2026',
    title: 'Trygghet & helse — sykehus, bjørnevett og «hva gjør jeg hvis»',
    body: 'SOS-siden har fått et trygghetskort: nærmeste sykehus for hvert stopp (Vancouver, Kamloops, Jasper, Banff, Calgary) med ett trykk for å ringe eller navigere, en kjapp bjørnesikkerhets-guide for Rockies, og «hva gjør jeg hvis»-scenarier (medisinsk om bord, bilulykke, mistet pass, forsinket fly). Alt virker uten nett.',
  },
  {
    date: '10. juli 2026',
    title: 'Gjør hele turen klar offline med ett trykk',
    body: 'Nytt «📴 Offline-beredskap»-kort på «I dag» med en beredskapsmåler. Trykk «Gjør alt klart offline», så lastes kart for hele ruten, vær og reisevakt ned samtidig — perfekt før strekk uten dekning som Icefields Parkway. Måleren viser når dere er 100 % klare.',
  },
  {
    date: '10. juli 2026',
    title: 'TripAdvisor og hotellsider — ett trykk unna, overalt',
    body: 'Hver restaurant, aktivitet og severdighet i dag-guiden har nå en 🦉 TripAdvisor-knapp, så dere raskt ser anmeldelser, åpningstider og bilder. Overnattings-boksen har fått både hotellets egen nettside og TripAdvisor. Og flere dager har fått ekstra konkrete spisesteder.',
  },
  {
    date: '10. juli 2026',
    title: 'Handlingsliste før avreise — hva, hvorfor, hvordan, pris',
    body: 'Øverst på Sjekkliste-siden ligger nå en komplett handlingsliste: hva som må bookes nå (Parks Canada-pass, Moraine Lake-shuttle, Banff Gondola, restaurantbord), reise-admin (eTA, cruise-innsjekk, flyseter, forsikring) og penger/praktisk — hver med hvorfor, hvordan, ca. pris og direktelenke. Huk av etter hvert.',
  },
  {
    date: '10. juli 2026',
    title: 'AI-assistenten vet hvilken dag det er',
    body: 'Spør dere AI-en «hva bør vi gjøre nå?», vet den nå faktisk hva «nå» betyr: dagens dato, hvilken reisedag dere er på (eller hvor mange dager til avreise) og dagens plan. Svarene blir mer treffsikre og til rett tid.',
  },
  {
    date: '10. juli 2026',
    title: 'Reisedokumentene — last opp flere om gangen, med kvittering',
    body: 'Dokument-arkivet lar dere nå laste opp flere PDF-er samtidig og gir tydelig kvittering på at det gikk bra (eller forklarer hva som mangler). Appen viser dessuten alltid hvem som er logget inn — grønn markør i menyen og på Dokumenter-siden.',
  },
  {
    date: '30. juni 2026',
    title: 'Nicholas\' hjemreise vises nå for seg selv',
    body: 'Nicholas er med på hele turen, men har egen bestilling og en annen vei hjem. Nå ser dere det tydelig: under «Dag for dag» 2.–3. august står foreldrenes rute via Portland som før, mens Nicholas\' rute via Toronto (WS640 Calgary→Toronto, så FI604 Toronto→Reykjavík) ligger i en egen lilla boks. Begge ruter møtes i Keflavík og tar samme fly hjem til Oslo. Billetter- og Dokument-sidene har også hver sin «Nicholas»-seksjon, så referanser, lugar og fly aldri blandes.',
  },
  {
    date: '30. juni 2026',
    title: 'Reisebekreftelsene — privat, rett i appen',
    body: 'Dokument-delen har fått et nytt «📄 Reisedokumenter»-kort. Logg inn, trykk «Last opp bekreftelse», og de fullstendige PDF-ene legges i ditt krypterte, private arkiv — kun du kan åpne dem, ingenting publiseres offentlig. Samtidig har vi finkjemt alle bookingreferanser, romtyper og lugar-detaljer mot de endelige bekreftelsene og rettet det som hadde løpt fra hverandre — blant annet hotellreferansene i Vancouver, Banff og Calgary, romtypen på Moose Hotel (2 Queens) og dekket på cruise-lugaren (Dekk 11).',
  },
  {
    date: '15. juni 2026',
    title: 'Del øyeblikk til Instagram, Facebook og Snapchat',
    body: 'Slik gjør dere: gå til Dagbok, så har hvert lagret innlegg nå en liten 📤-knapp oppe til høyre (ved siden av blyant og søppelbøtte). Trykk på den — på mobilen åpner telefonens eget delings-ark, der dere velger Instagram- eller Snapchat-historie, Facebook, Messenger eller WhatsApp, og bildet blir med. På PC åpnes Facebook-deling og lenken til følg-siden kopieres automatisk (Instagram og Snapchat kan kun deles fra mobilen). Følg-siden får også en pen forhåndsvisning med Moraine Lake når lenken deles.',
  },
  {
    date: '15. juni 2026',
    title: 'Kveldsrefleksjon — dagboken som nesten skriver seg selv',
    body: 'Fra klokka 21 på en reisedag dukker det opp et lite «🌙 Kveldsrefleksjon»-kort øverst i dagboken. Trykk «Oppsummer dagen», så leser Claude det dere faktisk noterte, brukte og fotograferte i løpet av dagen — og skriver en varm kladd dere kan redigere fritt. Har dere slått på varsler, kommer det også en vennlig påminnelse om kvelden.',
  },
  {
    date: '15. juni 2026',
    title: 'Reisebok med AI-skrevet forord',
    body: 'Ny «📖 Reisebok»-knapp i dagboken: Claude leser gjennom alle innleggene og skriver et personlig forord som binder hele turen sammen, før den setter sammen den ferdige boka med omslag, innholdsfortegnelse, bilder og notater — klar til å lagres som PDF eller skrives ut. Perfekt for å mimre når dere er hjemme igjen.',
  },
  {
    date: '7. juni 2026',
    title: 'Forsiden ser riktig ut i alle tema',
    body: 'Bytter dere til mørkt eller lyst tema, ser nå «For i dag» og «Reisens forløp» like forseggjorte ut som i Journal-temaet — med ryddige rader, lesbar skrift og pene knapper. Tidligere var forsiden bare stylet for papir-temaet.',
  },
  {
    date: '7. juni 2026',
    title: 'Trykk på bildene — se dem i full størrelse',
    body: 'Bildene i «Et glimt av dagen» og «Severdigheter langs ruten» er nå klikkbare. Trykk på et bilde, så åpnes det stort på skjermen med navn — bla videre med pilene eller sveip, og lukk med ✕ eller Esc. Endelig kan dere se Dawes Glacier og Moraine Lake i sin fulle prakt.',
  },
  {
    date: '7. juni 2026',
    title: 'Skarpere skrift i alle nettlesere',
    body: 'Skrifttypene følger nå med i selve appen i stedet for å hentes utenfra. Det betyr at den ser like forseggjort ut i Edge som i Chrome — og at teksten dukker opp raskere, også når dekningen er dårlig.',
  },
  {
    date: '6. juni 2026',
    title: 'Minst fem bilder på hver eneste dag',
    body: 'Nå har alle 18 dagene fått en egen bildestripe med minst fem utsiktsbilder — også fly-, cruise- og Alaska-havnedagene. Granville Island, Dawes Glacier, sjøotere, Nugget Falls, Gullfoss på vei hjem … Bla gjennom og kjenn på hver etappe.',
  },
  {
    date: '6. juni 2026',
    title: 'Mer å oppdage på hver dag',
    body: 'Fold ut en dag, så finner dere tre nye kort: 📷 Fototips (beste tidspunkt og motiv — for Sony-fotografen), 💡 «Visste du at?» med en liten historie, og ✍️ et dagboks-spørsmål med snarvei rett inn i dagboken. Perfekt lesestoff på de lange flyene.',
  },
  {
    date: '6. juni 2026',
    title: 'Høydepunkter å krysse av + lokale smaker',
    body: 'Ny ⭐ Høydepunkter-fane under Reisen: 16 «øyeblikk dere ikke må gå glipp av» som dere krysser av underveis, med fremdriftsmåler. Og på hver by står det nå en 🍽️ «Lokale smaker»-liste — fra aburi-sushi i Vancouver til Caesar-cocktail i Calgary. Stedene på kartet viser også bilde når dere trykker.',
  },
  {
    date: '6. juni 2026',
    title: 'Utsiktsbilder fra hele reisen',
    body: 'Nå har hver eneste dag fått et stort bilde øverst — flyvingen over skyene, cruiseskipet ved kai, Peyto Lake i turkis. Bla gjennom «Dag for dag» og kjenn på reisen før dere drar. 66 bilder, alle lagret lokalt i appen så de funker selv uten dekning oppe på Icefields Parkway.',
  },
  {
    date: '6. juni 2026',
    title: 'Severdigheter langs bilturen — med bilder',
    body: 'På biltur-dagene dukker det nå opp en egen stripe: «Severdigheter langs ruten». Mount Robson, Helmcken Falls, Moraine Lake, Three Sisters og et førtitalls andre stopp har fått sitt eget bilde — både i galleriet og som miniatyr på severdighetskortene. Trykk på et bilde for å hoppe rett til stedet.',
  },
  {
    date: '6. juni 2026',
    title: 'Kart fra forsiden og klikkbare hoteller',
    body: 'Forsiden har fått en egen «Åpne kartet»-knapp, så dere kommer rett til reisekartet med ett trykk. Og trykker dere på hotellnavnet i dagsplanen, åpnes hotellet i Google Maps med adresse og veibeskrivelse. Datoen på forsiden er også blitt skarpere å lese.',
  },
  {
    date: '16. mai 2026',
    title: 'Reisekart med personlighet',
    body: 'Appen har fått et levende kart med fjellene synlig som relieff, stedsnavn og 25 håndplukkede severdigheter underveis. Trykk på Moraine Lake, Mendenhall Glacier eller Stanley Park — så får dere bilde og en liten anmodning før dere reiser.',
  },
  {
    date: '16. mai 2026',
    title: 'Cruiset følger faktisk havet',
    body: 'Den stiplete cruise-linjen tar nå Inside Passage gjennom Strait of Georgia, opp Hecate Strait, og inn til Skagway via Lynn Canal — uten å skjære over noen øyer. Hele 70+ småpunkter for å holde linjen på vann.',
  },
  {
    date: '16. mai 2026',
    title: 'Nordlys-prediksjon for Alaska-nettene',
    body: 'Brief\'en henter live Kp-indeks fra NOAA og sier rett ut om dere bør gå på dekk klokka 23. Sommer-Alaska er knipsetid, men en storm kan endre alt.',
  },
  {
    date: '16. mai 2026',
    title: 'Foto-stempel på dagboksbildene',
    body: 'Hvert bilde dere tar i dagboken får et lite stempel i hjørnet: «tor 23. juli 2026 · Banff · 14°C regn». 50 år frem i tid vil dere takke appen for det.',
  },
  {
    date: '16. mai 2026',
    title: 'Familien hjemme kan sende hjerter',
    body: 'Del lenken usa26.kolakowski.no/folg — Margitas søster, naboen, Nicholas, hvem som helst kan klikke seg inn anonymt og trykke et lite hjerte. Telleren dukker opp i brief\'en.',
  },
  {
    date: '16. mai 2026',
    title: 'Klar for offline før dere går ombord',
    body: 'Service worker laster nå appen inn så hardt at dere kan åpne den i fjellheimen på Icefields Parkway uten dekning. PAKK-knappen øverst forhåndslaster neste etappe.',
  },
  {
    date: '15. mai 2026',
    title: 'Nytt design — feltjournal i stedet for app-blå',
    body: 'Hele appen er ompusset i en kremfarget editorial-stil med Newsreader-serif og IBM Plex. Tanken: dere skal føle dere som om dere bla i en reisedagbok, ikke en SaaS-portal. Bytt tilbake til mørkt eller lyst tema med ☀-knappen øverst hvis dere savner det gamle.',
  },
  {
    date: '15. mai 2026',
    title: 'Tidslinje fra dag 1 til dag 18',
    body: 'Forsiden viser nå reisens narrativ — dagens dag pulserer i lønnerødt, gårsdagen med et lite dagboknotat under, og resten av dagene komprimert ned. Klikk en dag for å se hele planen.',
  },
  {
    date: '15. mai 2026',
    title: 'Daglig brief «For i dag»',
    body: 'Hver morgen henter appen vær, soloppgang/-nedgang, lokalt tipping-skikk og ett konkret tips for dagen («Banff Gondola booker opp før 11. Reserver online før frokost»). Spør om noe annet under hvis det er noe spesifikt.',
  },
  {
    date: '15. mai 2026',
    title: 'Søk forstår spørsmål',
    body: 'Trykk forstørrelsesglasset og spør hva som helst — «Når lander vi i Vancouver?», «Hvor er det Wi-Fi på cruiset?». Foreslåtte spørsmål under feltet hjelper dere i gang.',
  },
];

export function unseenCount(){
  try {
    const seen = localStorage.getItem(LS_KEY);
    return seen === CHANGELOG_VERSION ? 0 : ENTRIES.filter(e => e.date >= (seen || '0000')).length;
  } catch { return ENTRIES.length; }
}

export function markSeen(){
  try { localStorage.setItem(LS_KEY, CHANGELOG_VERSION); } catch {}
}

function renderModal(){
  const html = `
    <div class="fj-news-hdr">
      <div>
        <div class="fj-news-eyebrow">Reisedagbokens loggbok</div>
        <h2>Hva er nytt</h2>
      </div>
      <button class="fj-news-close" aria-label="Lukk">×</button>
    </div>
    <p class="fj-news-intro">Hei dere to! Mens dere har sovet, har appen rørt på seg. Her er det viktigste.</p>
    <ol class="fj-news-list">
      ${ENTRIES.map(e => `
        <li>
          <span class="fj-news-date">${e.date}</span>
          <h3>${e.title}</h3>
          <p>${e.body}</p>
        </li>
      `).join('')}
    </ol>
    <p class="fj-news-foot">— Skrevet rett før kofferten ble pakket.</p>
  `;
  return html;
}

let _newsEl = null;
function ensurePanel(){
  if(_newsEl) return _newsEl;
  _newsEl = document.createElement('div');
  _newsEl.className = 'fj-news-panel';
  _newsEl.addEventListener('click', (e) => {
    if(e.target === _newsEl) closeChangelog();
  });
  document.body.appendChild(_newsEl);
  return _newsEl;
}

export function openChangelog(){
  const panel = ensurePanel();
  panel.innerHTML = `<div class="fj-news-box">${renderModal()}</div>`;
  panel.querySelector('.fj-news-close')?.addEventListener('click', closeChangelog);
  panel.classList.add('open');
  markSeen();
  // Oppdater pillen — fjern den siden alt nå er sett
  document.querySelectorAll('.fj-news-pill').forEach(el => el.classList.add('seen'));
}

export function closeChangelog(){
  if(_newsEl) _newsEl.classList.remove('open');
}

export function renderNewsPill(){
  const n = unseenCount();
  if(n === 0) return '';
  return `<button class="fj-news-pill" onclick="openChangelog()" title="Hva er nytt i appen" aria-label="Hva er nytt">Nytt</button>`;
}
